export function isValidDate(date) {
  return date && new Date(date) !== 'Invalid Date' && !isNaN(new Date(date));
}
